export default __webpack_public_path__ + "static/media/bg-image-nighttime.aa5161f5.jpg";